export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
              移动端畅享吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              吃瓜网站线路一针对移动端全面优化，无论手机还是平板，随时随地打开51吃瓜入口畅享全网最新吃瓜内容。快速加载、流畅浏览、省流省电。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 版本
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 版本
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 text-sm font-medium rounded-lg transition-colors cursor-pointer border border-background-200/70"
              >
                <i className="ri-qr-scan-line"></i>
                扫码访问
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20news%20feed%20interface%20with%20colorful%20cards%20and%20warm%20coral%20accents%2C%20clean%20UI%20design%2C%20mobile%20app%20interface%2C%20soft%20shadow%2C%20editorial%20product%20photography%2C%20minimal%20background%2C%20no%20text%20no%20letters&width=400&height=500&seq=app-screen-2026&orientation=portrait"
              alt="吃瓜网站移动端界面"
              className="w-56 md:w-64 h-auto rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}